import { TPagination } from "@custom-types/sorting";

import { AccountManager } from "./account-manager.model";

export type TIntermediariesPaginated = TPagination & {
  data: Array<IntermediaryModel>;
};

export interface IntermediaryModel {
  accountManager: AccountManager;
  accountManagerId: string;
  address: string;
  city: string;
  companyName: string;
  countryId: string;
  email: string;
  firstLetters: string;
  gender: number;
  homeNumber: number;
  homeNumberAddition: string;
  id: string;
  isLockedOut: boolean;
  lastName: string;
  lastNamePreffix: string;
  lockoutEndDateUtc: string;
  phoneNumber: string;
  street: string;
  userName: string;
  version: string;
  zipCode: string;
}

export class Intermediary implements IntermediaryModel {
  accountManager = new AccountManager();
  accountManagerId = "";
  address = "";
  city = "";
  companyName = "";
  countryId = "";
  email = "";
  firstLetters = "";
  gender = -1;
  homeNumber = -1;
  homeNumberAddition = "";
  id = "";
  isLockedOut = false;
  lastName = "";
  lastNamePreffix = "";
  lockoutEndDateUtc = "";
  phoneNumber = "";
  street = "";
  userName = "";
  version = "";
  zipCode = "";

  constructor(dto?: IntermediaryModel) {
    if (!dto) {
      return;
    }
    Object.assign(this, dto);
  }
}
